import { LANGUAGE_KEY } from 'config/translation';
import { CONFIG_WORD } from 'config/variables';
import CryptoJS from 'crypto-js';

export const setStringToLocalStorage = (
  key: string,
  value: string,
): boolean => {
  if (!CONFIG_WORD)
    throw new Error('CONFIG_WORD is not defined');

  if (key && value) {
    const textoCifrado = CryptoJS.AES.encrypt(
      value,
      CONFIG_WORD,
    ).toString();

    window.localStorage.setItem(key, textoCifrado);
    return true;
  }

  return false;
};

export const removeFromLocalStorage = (key: string): boolean => {
  if (!key) return false;
  window.localStorage.removeItem(key);
  return true;
};

export const getStringFromLocalStorage = (key: string): string | undefined => {
  if (!CONFIG_WORD)
    throw new Error('CONFIG_WORD is not defined');
  if (!key) return;

  const textoCifrado = window.localStorage.getItem(key);
  if (!textoCifrado) return;

  return CryptoJS.AES.decrypt(
    textoCifrado,
    CONFIG_WORD,
  ).toString(CryptoJS.enc.Utf8);
};

export const getStringFromLocalStorageCrypt = (
  key: string,
): string | undefined => {
  return window.localStorage.getItem(key) ?? '';
};

export const clearLocalStorage = () => {
  // If you want to keep some values in the local storage, you can add them here
  //"isPasswordExpired", "pendingEmail", "pendingRememberMe"
  const keysToPreserve = [LANGUAGE_KEY, 'rememberedEmail', 'redirect'];

  let keyValuesToPreserve: { [key: string]: string } = {};

  keysToPreserve.forEach(key => {
    const value = window.localStorage.getItem(key);
    if (value !== null) {
      keyValuesToPreserve[key] = value;
    }
  });

  window.localStorage.clear();

  Object.entries(keyValuesToPreserve).forEach(([key, value]) => {
    window.localStorage.setItem(key, value);
  });
};
